/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaAudioVolumeS1Icon24Solid = forwardRef('MediaAudioVolumeS1Icon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M10.512 3.677 5.572 8H3a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h2.571l4.941 4.323c.97.849 2.488.16 2.488-1.129V4.806c0-1.29-1.518-1.978-2.488-1.13Z" }),
        React.createElement("path", { d: "M16.773 7.227a1 1 0 1 0-1.414 1.414 4.751 4.751 0 0 1 0 6.718 1 1 0 1 0 1.414 1.414 6.75 6.75 0 0 0 0-9.546Z" })));
});
